import { HttpHeaders } from '@angular/common/http';

export const contentHeaders = new HttpHeaders();
contentHeaders.append('accept', 'application/json');
contentHeaders.append('content-type', 'application/json');